document.addEventListener('DOMContentLoaded', () => {
  window.incrementQuantity = function(element) {
    const input = element.parentElement.querySelector('.quantity-input');
    const max = input.getAttribute('max');
    const currentValue = parseInt(input.value);
    if (!max || currentValue < parseInt(max)) {
      input.value = currentValue + 1;
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  window.decrementQuantity = function(element) {
    const input = element.parentElement.querySelector('.quantity-input');
    const currentValue = parseInt(input.value);
    if (currentValue > 1) {
      input.value = currentValue - 1;
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  var width_screen = window.innerWidth;
  if (width_screen < 750) {
    var menuFooter = document.querySelectorAll('.footer__wrapper .footer__block-list .footer__block.footer__block--menu p');
    for (var i = 0; i < menuFooter.length; i++) {
      menuFooter[i].addEventListener('click', function(event) {
        var currentTarget = event.target;
        if ( currentTarget.classList.contains("active") === false ){
          currentTarget.classList.add("active");
        }else{
          currentTarget.classList.remove("active");
        }
      });
    }
  }

  var shopify_subscriptions_app_block = document.querySelector('.shopify_subscriptions_app_block');
  if (shopify_subscriptions_app_block){

    var subscriptions_labels = shopify_subscriptions_app_block.querySelectorAll('label');
    for (var i = 0; i < subscriptions_labels.length; i++) {
      subscriptions_labels[i].addEventListener('click', function(event) {
        var currentTarget = event.currentTarget;
        setTimeout(function () {
          if ( currentTarget.closest(".shopify_subscriptions_app_block_label").classList.contains("shopify_subscriptions_purchase_option_wrapper") === true ){
            var sale_price = currentTarget.closest(".shopify_subscriptions_app_block_label").querySelector('.shopify_subscriptions_in_widget_price').textContent;
            var compare_at_price = "";
          } else {
            var sale_price = currentTarget.closest(".shopify_subscriptions_app_block_label").querySelector('.shopify_subscriptions_in_widget_price').textContent;
            var compare_at_price = shopify_subscriptions_app_block.querySelector('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper .shopify_subscriptions_in_widget_price').textContent;
          }

          document.querySelector('buy-buttons .price-atc sale-price').textContent = sale_price;
          document.querySelector('buy-buttons .price-atc compare-at-price').textContent = compare_at_price;

          document.querySelector('product-quick-add buy-buttons .price-atc sale-price').textContent = sale_price;
          document.querySelector('product-quick-add buy-buttons .price-atc compare-at-price').textContent = compare_at_price;

          document.querySelector('product-quick-add .product-quick-add__variant .price-atc sale-price').textContent = sale_price;
          document.querySelector('product-quick-add .product-quick-add__variant .price-atc compare-at-price').textContent = compare_at_price;
        }, 0);
      });
    }
  }
  
});


// Intercepter toutes les suppressions de sections
(function() {
  const originalRemove = Element.prototype.remove;
  const originalRemoveChild = Node.prototype.removeChild;

  Element.prototype.remove = function() {
    if (this.classList && this.classList.contains('shopify-section--main-product')) {
      return;
    }
    return originalRemove.apply(this, arguments);
  };

  Node.prototype.removeChild = function(child) {
    if (child.classList && child.classList.contains('shopify-section--main-product')) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
})();